import React from "react";
import {motion} from "framer-motion";
import {fadeIn} from "../variants.jsx";
import {projectsData} from "../utils/data.jsx";

const Projects = () => {
	const handleProjectClick = (preview) => {
		window.open(preview, "_blank");
	};

	return (
		<section className="w-full pt-10 px-5 xl:pb-10">
			<div>
				<motion.h2
					variants={fadeIn("down")}
					initial="hidden"
					whileInView="show"
					viewport={{once: true, amount: 0.4}}
					className="text-3xl font-bold text-white text-left px-2"
				>
					Projects
				</motion.h2>
				<div className="flex flex-col xl:flex-row gap-y-10 sm:items-center pt-3">
					<div>
						{projectsData.map((project, index) => (
							<div
								key={index}
								onClick={() => handleProjectClick(project.preview)}
								role="button"
								className="grid grid-cols-5 gap-5 items-center justify-between sm:justify-center text-gray-300 px-2 py-5 hover:bg-gray-500/10 hover:rounded-3xl hover:text-white transition-all duration-300 cursor-pointer"
							>
								<div className="col-span-2">
									<img
										src={project.image}
										alt={project.alt}
										className="rounded-2xl"
									/>
								</div>
								<div className="col-span-3">
									<div className="flex justify-between">
										<h2 className="text-2xl font-semibold text-center lg:text-start">
											{project.name}
										</h2>
									</div>
									<p className="hidden md:block pt-2 italic">
										{project.description}
									</p>
									<div className="hidden md:flex gap-4 pt-3 justify-start lg:justify-end">
										{project.skills.map((skill, i) => (
											<p
												className="rounded-3xl text-sm font-semibold italic bg-blue-500/50 text-gray-300 hover:text-white px-3 py-1"
												key={i}
											>
												{skill}
											</p>
										))}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
				<div className='flex justify-center xl:justify-end p-12 lg:p-5'>
					<a href='https://github.com/ArsenZuna' target='_blank' rel='noreferrer'>
						<button
							type="submit"
							className="flex justify-center gap-2 items-center mx-auto shadow-xl text-lg bg-gray-300 backdrop-blur-md lg:font-semibold isolation-auto border-gray-300 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-blue-800/80 hover:text-white hover:font-semibold before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-3 py-2 overflow-hidden border-2 rounded-full group"
						>
							View More
							<svg
								className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-gray-300 text-gray-50 ease-linear duration-300 rounded-full border border-gray-700 group-hover:border-none p-2 rotate-45"
								viewBox="0 0 16 19"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
									className="fill-gray-800 group-hover:fill-gray-800"
								></path>
							</svg>
						</button>

					</a>
				</div>
			</div>
		</section>
	);
};

export default Projects;
